import { render } from "./slidefinish-28.vue?vue&type=template&id=350e407a&scoped=true"
import script from "./slidefinish-28.vue?vue&type=script&lang=js"
export * from "./slidefinish-28.vue?vue&type=script&lang=js"

import "./slidefinish-28.vue?vue&type=style&index=0&id=350e407a&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-350e407a"]])

export default __exports__